import { ApiCall } from "common/types/api";
import { Data } from "common/types/entity-tree";
import { CancellablePromise } from "common/types/promises";

export const entityTreeApi = (apiCall: ApiCall) => ({
  list: (siteName: string, entityName: string): CancellablePromise<Data> =>
    apiCall("get", `api/entities/${siteName}/${entityName}/tree`),
});
